import Link from "@/components/common/Link";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function AboutHomeOne() {
  const { messages } = useI18n();
  const about = messages.about;
  const aboutList = about.list;

  return (
    <section className="about-section style-one" style={{ backgroundImage: "url(/assets/img/core-img/shape4.png)" }}>
      {/* <!-- Divider --> */}
      <div className="divider"></div>
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-12 col-md-6">
            <div className="about-img pe-xxl-5 translateY10">
              <Image
                className="tilt-image w-auto h-auto"
                src="/assets/img/bg-img/auto-shop-selling-car-rims-stand-for-sale-of-allo-2025-03-13-11-15-53-utc.jpg"
                alt=""
                width={800}
                height={800}
                priority
              />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="section-heading text-white">
              <span className="subtitle" style={{ color: '#ffffff' }}>{about.subtitle}</span>
              <h2 className="mb-4" style={{ color: '#ffffff' }}>{about.title}</h2>
              <p className="mb-4" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>{about.description}</p>
              {/* <!-- About List --> */}
              <ul className="list-unstyled about-list mb-5">
                <li style={{ color: '#ffffff' }}>
                  <svg width="28" height="28" fill="#ffffff">
                    <use href="#checkIcon"></use>
                  </svg>
                  {aboutList.item1}
                </li>
                <li style={{ color: '#ffffff' }}>
                  <svg width="28" height="28" fill="#ffffff">
                    <use href="#checkIcon"></use>
                  </svg>
                  {aboutList.item2}
                </li>
                <li style={{ color: '#ffffff' }}>
                  <svg width="28" height="28" fill="#ffffff">
                    <use href="#checkIcon"></use>
                  </svg>
                  {aboutList.item3}
                </li>
                <li style={{ color: '#ffffff' }}>
                  <svg width="28" height="28" fill="#ffffff">
                    <use href="#checkIcon"></use>
                  </svg>
                  {aboutList.item4}
                </li>
              </ul>
              {/* <!-- Button --> */}
              <Link href="/about-us" className="btn btn-primary">
                <span>{about.moreAbout} <i className="ti ti-arrow-up-right"></i></span>
                <span>{about.moreAbout} <i className="ti ti-arrow-up-right"></i></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}
